import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "50%",
        x2: "50%",
        y1: "100%",
        y2: "0%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#1267EF"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#0BEADE"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#a)",
      "fill-rule": "nonzero",
      d: "M10.755 13.714H1.921C.86 13.714 0 12.843 0 11.77V1.946A1.936 1.936 0 0 1 1.92 0h8.835a1.916 1.916 0 0 1 1.914 1.887v2.356l2.038-1.07a.85.85 0 0 1 .864-.003.87.87 0 0 1 .429.76v5.9a.87.87 0 0 1-.863.873.84.84 0 0 1-.428-.114L12.67 9.52v2.352a1.926 1.926 0 0 1-1.916 1.843M3.427 2.286a1.714 1.714 0 1 0 .003 3.428 1.714 1.714 0 0 0-.003-3.428",
      transform: "translate(0 .143)"
    }, null, -1)
  ])))
}
export default { render: render }